import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState, useEffect } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/State";

// For Add State
function Add({ history }) {
  const statusOpt = [
    // 
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const [countryOpt, setCurrencyOpt] = useState([]);
  const fieldArr = [
    {
      id: 0,
      title: "Country",
      name: "country_id",
      type: "Dropdown",
      options: countryOpt,
    },
    { id: 1, title: "Title", name: "name", type: "TextInput" },
    { id: 2, title: "State Code", name: "state_code", type: "TextInput" },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    name: "",
    country_id: "",
    state_code: "",
    status: "",
  });


  function handleValidation() {
    let flag = true;
    let error = {}
    if (!fields.name) {
      error['name'] = "Please enter state name"
      flag = false
    }

    if (!fields.state_code) {
      error['state_code'] = "Please enter state code "
      flag = false
    }
    if (!fields.country_id) {
      error['country_id'] = "Please select country"
      flag = false
    }
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }
    setErrors({ ...errors, ...error })
    return flag;
  }

  function getCountryDatas() {
    configuration
      .getAPI({ url: "country/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          if (data.payload.length > 0) {
            data.payload.forEach((element) => {
              element.title = element.name;
              element.value = element.country_id;
              element.id = element.country_id;

              return element;
            });
          }
          setCurrencyOpt(data.payload);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  useEffect(() => {
    getCountryDatas();
  }, []);

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }

  const handleSubmit = () => {
    if (handleValidation()) {

    configuration
      .postAPI({ url: "state/create", params: fields })
      .then((data) => {
        if (data.status === 200) {
          history.push("/state");
          // setData(data.payload)
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
    }
  };
  return (
    <>
      <Breadcrumb module={labels.addState} />
      <AddEditSection
        title="Add State"
        path="/state"
        fields={fieldArr}
        fieldError={errors}

        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
